/* Custo cart — behaviour (theme path: assets/cart-custo.js)
   Flight-path gift track, sticky mobile bar, orphaned-charm sweeper,
   pack-upgrade nudge, cross-sell rail. Reads state from /cart.js + the
   section-rendered DOM; never keeps parallel state.
   Spec: landing-pages/CART-BUILD-SPEC.md */
(function () {
  'use strict';

  /* In drawer mode this file is loaded store-wide from snippets/modal-popup.liquid AND by
     the section on /cart itself. Two <script> elements with the same src execute twice even
     though the browser only fetches once — which would double the delegated click handler
     and add two items per Add. One run per document. */
  if (window.ccCartLoaded) return;
  window.ccCartLoaded = true;

  /* Gift tiers — codes live in the Fastrr coupon engine (not Shopify), so we
     surface code + copy, no auto-apply. Amounts in paise. Source: offers.md. */
  var TIERS = [
    { code: 'FREEKEY',        min: 59900,  gift: 'keychain',   worth: 199 },
    { code: 'FREECARDHOLDER', min: 150000, gift: 'cardholder', worth: 379 },
    { code: 'FREEWALLET',     min: 250000, gift: 'wallet',     worth: 399 },
    { code: 'FREEJOURNAL',    min: 350000, gift: 'journal',    worth: 599 }
  ];
  var MAX_MIN = TIERS[TIERS.length - 1].min;
  var PLANE = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M21 16v-2l-8-5V3.5a1.5 1.5 0 0 0-3 0V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L11 19v-5.5z"/></svg>';

  function fmt(paise) { return '₹' + Math.round(paise / 100).toLocaleString('en-IN'); }
  function amt(paise) { return '<span class="cc-amt">' + fmt(paise) + '</span>'; }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function postJSON(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  }
  function reloadCart() {
    var mc = document.querySelector('main-cart');
    if (mc && typeof mc.update === 'function') mc.update(function () { refresh(); });
    else window.location.reload();
  }

  /* ---------------- flight-path gift track ---------------- */
  function renderGift(total) {
    var el = document.getElementById('cc-gift');
    if (!el) return;
    if (!total) { el.hidden = true; return; }
    el.hidden = false;

    var unlocked = null, next = null;
    for (var i = 0; i < TIERS.length; i++) {
      if (total >= TIERS[i].min) unlocked = TIERS[i];
      else if (!next) next = TIERS[i];
    }
    var pct = Math.min(100, (total / MAX_MIN) * 100);

    var head;
    if (!unlocked) {
      head = '<p class="cc-gift-head">Add ' + amt(next.min - total) + ' more to unlock a <strong>free ' + next.gift +
        '</strong> <span style="color:#97A2AC">(worth ' + fmt(next.worth * 100) + ')</span></p>';
    } else {
      head = '<p class="cc-gift-head cc-gift-won">Free ' + unlocked.gift + ' unlocked' +
        (next ? ' · ' + amt(next.min - total) + ' more for a free ' + next.gift : '') + '</p>';
    }

    var dots = TIERS.map(function (t) {
      return '<span class="cc-gift-dot' + (total >= t.min ? ' hit' : '') + '" style="left:' + ((t.min / MAX_MIN) * 100) + '%"></span>';
    }).join('');
    var track = '<div class="cc-gift-track"><div class="cc-gift-route"></div>' +
      '<div class="cc-gift-fill" style="width:' + pct + '%"></div>' + dots +
      '<span class="cc-gift-plane" style="left:' + pct + '%">' + PLANE + '</span></div>';

    /* The copy-the-code row (Copy code + "Paste at checkout") was removed on 12-08-26. The gift
       bar now only tells the customer what they have unlocked and what the next tier is. */
    el.innerHTML = head + track;
  }

  /* ---------------- pack-upgrade nudge (CustoTag families only) ---------------- */
  var LADDER = {
    'custotag':                        { nhandle: 'custotag-pack-of-2', next: 47850419683547, nprice: 124900, label: 'Pack of 2' },
    'custotag-pack-of-2':              { nhandle: 'custotag-pack-of-3', next: 47850420535515, nprice: 179900, label: 'Pack of 3' },
    'custotag-pack-of-3':              { nhandle: 'custotag-pack-of-4', next: 47850420568283, nprice: 229900, label: 'Pack of 4' },
    'custotag-pack-of-4':              { nhandle: 'custotag-pack-of-6', next: 47850420666587, nprice: 329900, label: 'Pack of 6' },
    'custotag-for-android':            { nhandle: 'custotag-for-android-pack-of-2', next: 48226501329115, nprice: 149900, label: 'Pack of 2' },
    'custotag-for-android-pack-of-2':  { nhandle: 'custotag-for-android-pack-of-3', next: 48226506899675, nprice: 214900, label: 'Pack of 3' },
    'custotag-for-android-pack-of-3':  { nhandle: 'custotag-for-android-pack-of-4', next: 48226507751643, nprice: 274900, label: 'Pack of 4' },
    'custotag-for-android-pack-of-4':  { nhandle: 'custotag-for-android-pack-of-6', next: 48226509750491, nprice: 369900, label: 'Pack of 6' }
  };

  /* nprice above is a FALLBACK. The real price is fetched from Shopify once per handle so the
     cart's upsell nudge can never quote a stale price — five hardcoded copies had drifted by
     21.08.26, including the Android ladder which had been wrong since the 03.08 rise. */
  var _npDone = {};
  function syncLadderPrices() {
    Object.keys(LADDER).forEach(function (k) {
      var l = LADDER[k];
      if (!l.nhandle || _npDone[l.nhandle]) return;
      _npDone[l.nhandle] = true;
      fetch('/products/' + l.nhandle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || !d.variants) return;
          var v = d.variants.filter(function (x) { return x.id === l.next; })[0] || d.variants[0];
          if (v && v.price > 0 && v.price !== l.nprice) { l.nprice = v.price; scheduleRefresh(); }
        })
        .catch(function () { /* keep the fallback */ });
    });
  }

  var UP_IC = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';

  function familyOf(handle) {
    if (/^custotag-for-android/.test(handle)) return 'cta';
    if (/silicone|collar-case/.test(handle)) return 'case';
    if (/^custotag/.test(handle)) return 'cti';
    if (/^(passport-cover|couple-passport-cover|family-passport-cover)/.test(handle)) return 'pc';
    if (/^(zippered-travel-organizer|family-passport-holder-with-zipper)/.test(handle)) return 'zto';
    if (/^travel-organizer/.test(handle)) return 'to';
    if (/^dual-passport-holder/.test(handle)) return 'dph';
    if (/^passport-wallet/.test(handle)) return 'pw';
    return null;
  }

  /* The nudge belongs directly under the line it is talking about, not at the foot of the
     list — with three products in the bag "Add a 4th" floating below all of them names no
     product. That means living INSIDE <cart-items>, which the theme's update() wipes with
     replaceChildren() on every change, so we keep our own reference to the node and put it
     back each render. Every write here is guarded on "is it already right?": the same
     MutationObserver that triggers refresh() watches cart-items, so an unconditional write
     would re-trigger itself forever. */
  var nudgeEl = null;

  function renderNudge(cart) {
    if (!nudgeEl) nudgeEl = document.getElementById('cc-nudge');
    var el = nudgeEl;
    if (!el) return; /* section setting show_upsell is off */
    /* Skip rule mirrors the Liquid lock: a line is off-limits only if it has attached add-on
       lines (upgrading would orphan them straight into the sweeper) or printable
       personalisation. NOT on bare _itemKey — the options engine stamps that on every add
       from an engine PDP, so keying on it hid the nudge for every real customer's CustoTag. */
    var kids = {};
    cart.items.forEach(function (it) {
      var pk = it.properties && (it.properties._parentKey || it.properties._ccParent);
      if (pk) kids[pk] = true;
    });
    function hasVisibleProps(p) {
      for (var k in p) {
        if (!Object.prototype.hasOwnProperty.call(p, k) || k.charAt(0) === '_') continue;
        if (/Personalized Name|Add charm/.test(k)) continue;
        var v = String(p[k] == null ? '' : p[k]).trim();
        if (v !== '' && v !== 'On' && v !== 'Off') return true;
      }
      return false;
    }
    var cand = null;
    cart.items.forEach(function (it) {
      var p = it.properties || {};
      if (p._parentKey || p._ccParent) return;     /* an add-on line, not a product */
      if (p._itemKey && kids[p._itemKey]) return;  /* has attached add-ons */
      if (hasVisibleProps(p)) return;              /* personalised */
      var l = LADDER[it.handle];
      if (l && it.quantity === 1 && (!cand || it.final_price > cand.item.final_price)) cand = { item: it, l: l };
    });
    if (!cand || cand.l.nprice <= cand.item.final_price) {
      if (!el.hidden) el.hidden = true;
      if (el.innerHTML !== '') el.innerHTML = '';
      return;
    }
    var delta = cand.l.nprice - cand.item.final_price;

    /* Units in play. The old copy always said "Add 1 more", which was wrong on the last rung:
       Pack of 4 → Pack of 6 adds two. Read the counts instead of assuming. */
    var curUnits = parseInt((cand.item.handle.match(/pack-of-(\d+)/) || [0, 1])[1], 10) || 1;
    var nextUnits = parseInt((cand.l.label.match(/(\d+)/) || [0, curUnits + 1])[1], 10) || curUnits + 1;
    var more = nextUnits - curUnits;
    var ORD = { 2: '2nd', 3: '3rd', 4: '4th', 5: '5th', 6: '6th', 8: '8th' };
    /* paise in, paise out — ceil to a whole rupee so the per-unit figure is never quoted below
       what it actually works out to (₹466.50 shows as ₹467, never ₹466) */
    var each = Math.ceil(cand.l.nprice / nextUnits / 100) * 100;

    /* Lead with the marginal cost — the only number that answers "what does one more cost me?"
       — and let the per-unit rate carry the argument. The pack's full price is the button's job
       and the cart's; repeating it here just made three prices compete in one sentence. */
    var lead = (more === 1 && ORD[nextUnits])
      ? 'Add a ' + ORD[nextUnits] + ' for ' + amt(delta)
      : 'Add ' + more + ' more for ' + amt(delta);

    var html =
      '<span class="cc-nudge-ic">' + UP_IC + '</span>' +
      '<div class="cc-nudge-txt">' +
        '<span class="cc-nudge-lead">' + lead + '</span>' +
        '<span class="cc-nudge-sub"><strong>' + cand.l.label + '</strong> · ' + fmt(each) + ' each</span>' +
      '</div>' +
      '<button type="button" class="cc-nudge-btn" data-old="' + cand.item.key + '" data-new="' + cand.l.next + '">Upgrade</button>';
    if (el.innerHTML !== html) el.innerHTML = html;
    if (el.hidden) el.hidden = false;

    /* park it against its own row */
    var row = document.querySelector('cart-item[cart-item-key="' + cand.item.key + '"]');
    if (row && row.nextElementSibling !== el) row.after(el);
  }

  /* ---------------- cross-sell rail ---------------- */
  function renderXsell(cart) {
    var el = document.getElementById('cc-xsell');
    if (!el) return;
    var fams = {};
    cart.items.forEach(function (it) { var f = familyOf(it.handle); if (f) fams[f] = true; });
    var hasCT = fams.cti || fams.cta;
    var want = [];
    /* No 'pc' recommendation — passport covers are personalised-only, can't one-click add */
    if ((fams.pc || fams.dph || fams.pw || fams.to || fams.zto) && !hasCT) want.push('ct');
    if (hasCT && !fams.case) want.push('case');
    if ((fams.pc || hasCT) && !fams.to && !fams.zto) want.push('to');
    want = want.slice(0, 3);
    var any = false;
    el.querySelectorAll('.cc-x-card').forEach(function (c) {
      var show = want.indexOf(c.getAttribute('data-x')) > -1;
      c.hidden = !show; if (show) any = true;
    });
    el.hidden = !any || !cart.item_count;
  }

  /* delegated clicks — nudge + rail re-render, so bind once on document */
  document.addEventListener('click', function (e) {
    var up = e.target.closest ? e.target.closest('.cc-nudge-btn') : null;
    if (up) {
      up.disabled = true; up.textContent = 'Upgrading…';
      postJSON('/cart/add.js', { items: [{ id: parseInt(up.getAttribute('data-new'), 10), quantity: 1 }] })
        .then(function () { return postJSON('/cart/change.js', { id: up.getAttribute('data-old'), quantity: 0 }); })
        .then(reloadCart).catch(function () { up.disabled = false; up.textContent = 'Upgrade'; });
      return;
    }
    var add = e.target.closest ? e.target.closest('.cc-x-add') : null;
    if (add) {
      var card = add.closest('.cc-x-card');
      add.disabled = true; add.textContent = 'Added';
      postJSON('/cart/add.js', { items: [{ id: parseInt(card.getAttribute('data-variant'), 10), quantity: 1 }] })
        .then(reloadCart).catch(function () { add.disabled = false; add.textContent = 'Add'; });
    }
  });

  /* ---------------- Fastrr checkout ----------------
     The SDK turns our empty #headless-button div into its own BUY NOW control. Until it does,
     the native submit is the only CTA — so hide the native one only after hydration, and put it
     back if Fastrr ever tears its button down. */
  function fastrrButton() {
    var host = document.getElementById('headless-button');
    var btn = host && host.querySelector('button, a, [role="button"]');
    return btn || null;
  }

  /* The SDK scans for .shiprocket-headless once at init, and never again — so in the drawer
     it finds nothing: our node lives inside the detached copy of the cart that modal-popup
     keeps, and only enters the document when the customer opens the drawer. Waiting does not
     help (checked at +4s). But hydration is not the only door: the button the SDK builds is
     just `onclick="shiprocketCheckoutEvents.buyCart(event)"`, and that call works from any
     element — verified from the drawer, it opens the same overlay with the cart, the coupon
     list and the saved address. So when the SDK is loaded but our node is bare, the theme's
     own Checkout button stays visible and routes into Fastrr itself. Native submit — which
     lands on Shopify checkout and loses COD, coupons and the gift codes — is the last resort,
     for when the SDK never loaded at all. */
  function fastrrSDK() {
    var ev = window.shiprocketCheckoutEvents;
    return ev && typeof ev.buyCart === 'function' ? ev : null;
  }

  function nativeCheckout() {
    return document.querySelector('#cart-form [name="checkout"], button[name="checkout"][form="cart-form"]');
  }

  document.addEventListener('click', function (e) {
    var chk = e.target.closest ? e.target.closest('#cart-form [name="checkout"], button[name="checkout"][form="cart-form"]') : null;
    if (!chk || fastrrButton()) return;
    var sdk = fastrrSDK();
    if (!sdk) return;
    e.preventDefault();
    sdk.buyCart(e);
  });

  function syncCheckoutButtons() {
    var host = document.getElementById('headless-button');
    if (!host) return;
    var hydrated = !!fastrrButton();
    host.classList.toggle('cc-fastrr-ready', hydrated);
    var native = document.querySelector('#cart-form [name="checkout"], button[name="checkout"][form="cart-form"]');
    if (native) native.classList.toggle('cc-checkout-fallback-only', hydrated);
  }

  function watchFastrr() {
    var host = document.getElementById('headless-button');
    if (!host) return;
    syncCheckoutButtons();
    new MutationObserver(syncCheckoutButtons).observe(host, { childList: true, subtree: true });
  }

  /* ---------------- sticky mobile bar ---------------- */
  function syncSticky(total) {
    var bar = document.getElementById('cc-sticky');
    if (!bar) return;
    var totalEl = document.getElementById('cc-sticky-total');
    var saveEl = document.getElementById('cc-sticky-save');
    if (totalEl) totalEl.textContent = fmt(total);
    var savingsNode = document.querySelector('[data-cc-savings]');
    if (saveEl) {
      var savings = savingsNode ? parseInt(savingsNode.getAttribute('data-cc-savings'), 10) : 0;
      if (savings > 0) { saveEl.hidden = false; saveEl.textContent = 'saving ' + fmt(savings); } else saveEl.hidden = true;
    }
    var mainCart = document.querySelector('main-cart');
    if ((mainCart && mainCart.hasAttribute('is-empty')) || !total) bar.classList.add('hidden');
  }
  function initSticky() {
    var bar = document.getElementById('cc-sticky');
    var summary = document.getElementById('cc-summary');
    if (!bar || !summary) return;
    bar.querySelector('#cc-sticky-btn').addEventListener('click', function () {
      /* Fastrr first — its hydrated button is the real checkout. Only fall back to the native
         submit (which lands on Shopify checkout) if Fastrr never rendered. */
      var fastrr = fastrrButton();
      if (fastrr) { fastrr.click(); return; }
      var real = nativeCheckout() || document.querySelector('[name="checkout"]');
      if (real) real.click(); /* the delegated handler above routes it into Fastrr if the SDK is up */
      else if (fastrrSDK()) fastrrSDK().buyCart(new MouseEvent('click'));
      else document.getElementById('cart-form') && document.getElementById('cart-form').requestSubmit();
    });
    new IntersectionObserver(function (entries) {
      var mainCart = document.querySelector('main-cart');
      var empty = mainCart && mainCart.hasAttribute('is-empty');
      bar.classList.toggle('hidden', entries[0].isIntersecting || empty);
    }, { threshold: 0.05 }).observe(summary);
  }

  /* ---------------- orphaned add-on (charm) sweeper ----------------
     Two-strike: the options engine's billing line can legitimately sit in the cart
     for a moment before its parent (the add-on posts first on some ATC paths), and
     deleting on a single /cart.js snapshot swept real paid-name/charm lines mid-add
     (5 under-billed orders on 13-08-26). A line is only removed if it is still
     orphaned on a second look >= ORPHAN_GRACE later; a resolved orphan (parent
     arrived, or line gone) is forgotten. First sighting schedules its own re-check
     so a genuine orphan doesn't linger until the next cart mutation. */
  var ORPHAN_GRACE = 4000;
  var sweeping = false, orphanSeen = {};
  function sweepOrphans(cart) {
    if (sweeping) return;
    var keys = {};
    cart.items.forEach(function (it) { if (it.properties && it.properties._itemKey) keys[it.properties._itemKey] = true; });
    var now = Date.now(), present = {}, orphan = null, firstSighting = false;
    cart.items.forEach(function (it) {
      var pk = it.properties && (it.properties._parentKey || it.properties._ccParent);
      if (!pk || keys[pk]) return;
      present[it.key] = true;
      if (!orphanSeen[it.key]) { orphanSeen[it.key] = now; firstSighting = true; return; }
      if (!orphan && now - orphanSeen[it.key] >= ORPHAN_GRACE) orphan = it;
    });
    Object.keys(orphanSeen).forEach(function (k) { if (!present[k]) delete orphanSeen[k]; });
    if (!orphan) {
      if (firstSighting) setTimeout(refresh, ORPHAN_GRACE + 500);
      return;
    }
    sweeping = true;
    postJSON('/cart/change.js', { id: orphan.key, quantity: 0 }).then(function () {
      sweeping = false;
      delete orphanSeen[orphan.key];
      var mc = document.querySelector('main-cart');
      if (mc && typeof mc.update === 'function') mc.update(function () { refresh(); }); else refresh();
    }).catch(function () { sweeping = false; });
  }

  /* ---------------- refresh loop ---------------- */
  var pending = null, lastTotal = -1;
  /* Liquid stamps is-empty at render time and the whole empty/full switch hangs off it
     (.cc-cart[is-empty] .#cart / .cc-cart:not([is-empty]) .#cart-empty). The theme re-renders
     cart-items and subtotal-price in place but never touches the host's attributes, so emptying
     the cart from the page used to leave BOTH blocks hidden — a blank cart. Keep it in sync. */
  function syncEmpty(cart) {
    var host = document.querySelector('main-cart');
    if (!host) return;
    var isEmpty = cart.item_count === 0;
    if (isEmpty === host.hasAttribute('is-empty')) return; /* no-op: don't retrigger the observer */
    if (isEmpty) host.setAttribute('is-empty', ''); else host.removeAttribute('is-empty');
  }

  /* "Your bag · N items" is Liquid, and the theme's update() only swaps cart-items and
     subtotal-price — so the eyebrow kept whatever count the page was rendered with. Same
     wording as the section (cart.item_count, units not lines). */
  function syncCount(cart) {
    var el = document.querySelector('.cc-count');
    if (!el) return;
    el.textContent = cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's');
  }

  function refresh() {
    getCart().then(function (cart) {
      if (cart.total_price !== lastTotal) {
        lastTotal = cart.total_price;
        renderGift(cart.total_price);
        syncSticky(cart.total_price);
      }
      syncEmpty(cart);
      syncCount(cart);
      var mcs = document.querySelector('modal-popup main-cart');
      if (mcs && mcs.ccSyncScroll) mcs.ccSyncScroll();
      renderNudge(cart);
      renderXsell(cart);
      sweepOrphans(cart);
    }).catch(function () {});
  }
  function scheduleRefresh() { clearTimeout(pending); pending = setTimeout(refresh, 300); }

  function init() {
    var mainCart = document.querySelector('main-cart');
    if (!mainCart || mainCart.ccInit) return;
    mainCart.ccInit = true;
    syncLadderPrices();
    var giftEl = document.getElementById('cc-gift');
    var initial = giftEl ? parseInt(giftEl.getAttribute('data-cart-total'), 10) : 0;
    var subEl = document.querySelector('[data-cc-subtotal]');
    if (!initial && subEl) initial = parseInt(subEl.getAttribute('data-cc-subtotal'), 10);
    lastTotal = initial;
    renderGift(initial);
    watchFastrr();
    initSticky();
    syncSticky(initial);

    var mo = new MutationObserver(scheduleRefresh);
    var ci = mainCart.querySelector('cart-items'); if (ci) mo.observe(ci, { childList: true, subtree: true });
    var sp = mainCart.querySelector('subtotal-price'); if (sp) mo.observe(sp, { childList: true, subtree: true });
    mo.observe(mainCart, { attributes: true, attributeFilter: ['is-empty'] });

    refresh(); /* catch nudge/xsell/orphans on first paint */
  }

  /* ---------------- drawer (slide-out cart) ----------------
     In drawer mode the theme's modal-popup fetches /cart once at page load, keeps
     [data-main-cart] detached, and moves that same node into the modal each time the
     customer opens it. Two consequences for this file:
       - the node is not in the document at DOMContentLoaded, and on a product page it
         may never be unless the drawer is opened, so init() has to run on open;
       - a <script> inside the fetched HTML never executes (DOMParser stamps parsed
         scripts as already-started), which is why this file is loaded from
         snippets/modal-popup.liquid store-wide instead of from the section.
     The node is reused across opens, hence the ccInit guard in init(). The kept copy
     also goes stale the moment anything is added elsewhere, so refetch on every open —
     main-cart.update() re-renders the section and our MutationObserver takes it from there. */
  /* Scroll cue for the drawer's item list. iOS never shows a persistent scrollbar, so the CSS
     fade on the footer's top edge is the "more below" signal — this clears it (data-cc-at-end)
     when the list is at its end or too short to scroll, so the fade can't lie. */
  function watchDrawerScroll(mc) {
    var col = mc.querySelector('[class~="#cart-col"]');
    if (!col || col.ccScrollWatch) return;
    col.ccScrollWatch = true;
    var sync = function () {
      var atEnd = col.scrollHeight - col.scrollTop - col.clientHeight < 6;
      var scrollable = col.scrollHeight - col.clientHeight > 6;
      if (atEnd || !scrollable) mc.setAttribute('data-cc-at-end', '');
      else mc.removeAttribute('data-cc-at-end');
    };
    mc.ccSyncScroll = sync; /* refresh() re-runs it after every cart change — ResizeObserver
                               is frame-aligned and a background tab renders no frames */
    col.addEventListener('scroll', sync, { passive: true });
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(sync);
      ro.observe(col); /* drawer resized (URL bar, rotation) */
      var ci = col.querySelector('cart-items'); if (ci) ro.observe(ci); /* items added/removed */
    }
    sync();
  }

  function bootDrawer() {
    var slot = document.querySelector('modal-popup [data-content]');
    if (!slot) return;
    new MutationObserver(function () {
      var mc = slot.querySelector('main-cart');
      if (!mc) return;
      init();
      watchDrawerScroll(mc);
      if (typeof mc.update === 'function') mc.update(function () { refresh(); });
      else refresh();
    }).observe(slot, { childList: true });
  }

  function boot() { init(); bootDrawer(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
